import * as React from 'react'
import {
  RichTextInput,
  RichTextInputToolbar,
  LevelSelect,
  FormatButtons,
  ListButtons,
  LinkButtons,
  QuoteButtons,
  ClearButtons,
  AlignmentButtons,
} from 'ra-input-rich-text'
import { ColorButtons } from './ColorButtons'
// import CustomLevelSelect from './CustomLelelSelect'

export const CustomRichTextInput = ({ size, ...props }) => (
  <RichTextInput
    toolbar={
      <RichTextInputToolbar>
        <LevelSelect size={size} />
        {/* <CustomLevelSelect size={size} /> experemental */}
        <FormatButtons size={size} />
        <ColorButtons size={size} />
        <AlignmentButtons size={size} />
        <ListButtons size={size} />
        <LinkButtons size={size} />
        <QuoteButtons size={size} />
        <ClearButtons size={size} />
      </RichTextInputToolbar>
    }
    {...props}
  />
)
